import React from "react";

import Virat from "../../../../assets/virat.png";

import styled from "styled-components";

const Container = styled.div`
  width: 99%;
  height: 50px;
  margin-bottom: 10px;
  background: white;
  margin-bottom: 10px;
  cursor: pointer;
`;
const LeftSide = styled.div`
  width: 55%;
  height: 100%;
  float: left;
`;
const User = styled.div`
  width: 50%;
  height: 100%;
  float: left;
`;
const UserImage = styled.div`
  width: 30%;
  height: 100%;
  float: left;
  text-align: center;
`;
const Image = styled.img`
  width: 35px;
  height: 35px;
  border: 1px solid #eee;
  border-radius: 100%;
  background: white;
  margin-top: 7px;
`;
const UserName = styled.div`
  width: 66%;
  height: 100%;
  float: right;
`;
const Name = styled.p`
  font-size: 0.9em;
  font-weight: 500;
  padding: 15px 0 0 0;
  margin: 0;
  text-align: center;
`;
const ProducQuantity = styled.div`
  width: 50%;
  height: 100%;
  float: right;
  text-align: center;
`;
const Quantity = styled.p`
  font-size: 0.9em;
  padding: 15px 0 0 0;
  margin: 0;
`;
const RightSide = styled.div`
  width: 45%;
  height: 100%;
  float: right;
`;
const Total = styled.div`
  width: 50%;
  height: 100%;
  float: left;
  text-align: center;
`;
const Price = styled.p`
  font-size: 0.9em;
  font-weight: 500;
  padding: 15px 0 0 0;
  margin: 0;
`;
const Actions = styled.div`
  width: 50%;
  height: 100%;
  float: right;
  text-align: center;
`;
const Button = styled.button`
  font-size: 0.8em;
  font-weight: 500;
  color: #276fb7;
  margin-top: 17px;
  border: none;
  background: none;
  outline: none;
  cursor: pointer;
`;
const CancelButton = styled.button`
  font-size: 1em;
  font-weight: 500;
  color: black;
  margin-top: 15px;
  border: none;
  background: none;
  outline: none;
  cursor: pointer;
  padding: 0 5%;
`;
const PendingOrder = (props) => {
  let title = "Nice";
  props.order.orderedProducts.map((product) => {
    console.log("Title", title);
    console.log(product.name);
    if (product.name) {
      return (title = title.concat(", ", product.name));
    } else {
      return;
    }
  });

  return (
    <Container
      onClick={() => {
        props.orderViewHandler(props.order._id);
      }}
    >
      <LeftSide>
        <User>
          {/* <UserImage>
                       <Image src={Virat} alt="user-name"/>
                   </UserImage>
                   <UserName>
                       <Name>Virat kohli</Name>
                   </UserName> */}
          <Name>
            {title.length > 22 ? title.substring(0, 21) + ".." : title}
          </Name>
        </User>
        <ProducQuantity>
          <Quantity>{props.order.orderedProducts.length} Items</Quantity>
        </ProducQuantity>
      </LeftSide>
      <RightSide>
        <Total>
          <Price>{props.order.total} TK</Price>
        </Total>
        <Actions>
          <Button>VIEW ORDER</Button>
        </Actions>
      </RightSide>
    </Container>
  );
};

export default PendingOrder;
